// Visual-only role chip helpers. Reads year_role.committee_assignments and
// the committee tree to build deduplicated full-path chips in the strict
// sequence: Position · 1st Level Committee · SubCommittee · 2nd Level Sub.
// Never mutates member data.

function committeePathNames(committeeId, byId) {
    const parts = [];
    let cur = byId[committeeId];
    let guard = 0;
    while (cur && guard < 10) {
        if (cur.name) parts.unshift(cur.name);
        cur = cur.parent_id ? byId[cur.parent_id] : null;
        guard += 1;
    }
    return parts;
}

export function buildRolePathChips(member, committees = []) {
    const assignments = member?.year_role?.committee_assignments || [];
    const byId = Object.fromEntries((committees || []).map((c) => [c.id, c]));

    const seen = new Set();
    const chips = [];
    for (const a of assignments) {
        const path = committeePathNames(a.committee_id, byId);
        const positions = (a.positions || []).map((p) => String(p || "").trim()).filter(Boolean);
        for (const pos of positions.length ? positions : [""]) {
            const segments = [pos, ...path].filter(Boolean);
            // Collapse adjacent identical tokens (case-insensitive) — e.g. a
            // "Secretary" position under a top-level committee also named
            // "Secretary" should render "Secretary · <Club>", not repeat.
            const collapsed = segments.filter((s, i) => i === 0 || s.toLowerCase() !== segments[i - 1].toLowerCase());
            const label = collapsed.join(" · ");
            if (!label) continue;
            const key = label.toLowerCase();
            if (seen.has(key)) continue;
            seen.add(key);
            chips.push(label);
        }
    }
    if (!chips.length) {
        const fallback = String(member?.role_display || member?.position || "").trim();
        if (fallback) chips.push(fallback);
    }
    return chips;
}

export function hasLeadershipPosition(member) {
    for (const a of member?.year_role?.committee_assignments || []) {
        for (const p of a.positions || []) {
            const s = String(p || "").toLowerCase();
            if (s.includes("president") || s.includes("secretary")) return true;
        }
    }
    return false;
}
